export type AspectRatio = "1:1" | "16:9" | "4:3" | "3:2" | "5:4";

function calculateDimension(width?: number, height?: number, aspectRatio?: AspectRatio) {
    if (width && height) {
        return {width, height};
    }
    const [wRatio, hRatio] = (aspectRatio ?? "5:4").split(":").map(Number);

    if (width) {
        height = (width / wRatio) * hRatio;
    } else if (height) {
        width = (height / hRatio) * wRatio;
    }

    return {width, height};
}

export default calculateDimension;
